import React, { useEffect, useState } from 'react';

const Profile = () => {
    const [customerName, setCustomerName] = useState('');
    const [mobileNo, setMobileNo] = useState('');

    useEffect(() => {
        const customerName = localStorage.getItem("smc-csp-customer-name");
        const mobileNo = localStorage.getItem("MobileNo");

        if (customerName) setCustomerName(customerName);
        if (mobileNo) setMobileNo(mobileNo);
    }, []);

    console.log(customerName, "Name")
    console.log(mobileNo, "Mobile")
    return (
        <div className="dashboard">
            <img src="https://www.smcinsurance.com/myaccount/js/assets/Images/profile-pic.jpg" alt="Profile Picture" className="profile-pic" />
            <div className="profile-info">
                <h2>{customerName}</h2>
                <p>Mobile: {mobileNo}</p>
            </div>
            {/*<div className="details">*/}
            {/*    <div><strong>Role:</strong> Software Engineer</div>*/}
            {/*    <div><strong>Location:</strong> New York, USA</div>*/}
            {/*    <div><strong>Joined:</strong> January 2022</div>*/}
            {/*    <div><strong>Status:</strong> Active</div>*/}
            {/*</div>*/}
        </div>
    );
};

export default Profile;
